import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Checkmark = ({
  height = 12,
  color = colors.white,
  isColorInherited = false,
  width,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-temporary-fix
    height={height}
    width={width || Number(height) * 1.25}
    viewBox="0 0 10 8"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.47278 0.162394C9.26705 -0.0541312 8.9336 -0.0541312 8.72787 0.162394L3.50484 5.66045L1.27213 3.31018C1.06644 3.09367 0.732949 3.09367 0.527255 3.31018L0.15427 3.70283C-0.0514234 3.91934 -0.0514234 4.27041 0.15427 4.48692L2.76318 7.23322C2.79577 7.26754 2.82998 7.29909 2.86554 7.32798L3.13856 7.6154C3.34425 7.8319 3.67774 7.8319 3.88345 7.6154L4.18015 7.30308C4.20516 7.28118 4.22945 7.25789 4.25294 7.23322L4.6259 6.84057L4.62268 6.83719L9.84574 1.33912C10.0514 1.12259 10.0514 0.771544 9.84574 0.555025L9.47278 0.162394Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
